module.exports = __webpack_public_path__ + "static/media/icon-delete.2cce9f68.svg";